export default "p {\n  background: red;\n}";